import React, { useRef, useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AddIcon from "@mui/icons-material/Add";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import { styled } from "@mui/material/styles";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

import { useAuth } from "../../../../authContext/AuthContext";
import "./DataValidation.css";
import {
  Dialog,
  Chip,
  DialogContent,
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Avatar,
  LinearProgress,
} from "@mui/material";
import DataValidationUploadIcon from "../../../../../src/assets/data_validation_upload_icon.png";
import ErrorDownloadIcon from "../../../../../src/assets/error_download_icon.png";
import DataValidationFileIcon from "../../../../../src/assets/data_validation_file_icon.png";
import DataValidationPatientRecord from "../../../../../src/assets/data_validation_patient_record.png";
import {
  conversionFileTracking,
  dataValidationFileConversion,
  dataValidationFileDownloadValidation,
  dataValidationFileValidation,
  dataValidationUploadProcess,
  setActiveStep,
  setDataValidationErrorModal,
  setUploadFile,
  validationFileTraking,
} from "./DataValidationSlicer";
import axios from "axios";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const DataValidation = () => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [isFileUploadProgress, setIsFileUploadProgress] = useState(0);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const { userEmail } = useAuth();
  const orgName = "iMedX";
  const sliceduser = String(userEmail).split("@")[0];
  const currentTimestamp = new Date().getTime();
  const loadIds = `${sliceduser}-${orgName}-${currentTimestamp}`;
  const created_by = sessionStorage.getItem("userId");

  const {
    activeStep,
    dataValidationErrorModal,
    uploadFile,
    dataValidationUploadProcessData,
    dataValidationFileValidationData,
    dataValidationFileConversionData,
    dataValidationFileDownloadValidationData,
    dataValidationFileTraking,
    dataConversionFileTracking,
  } = useSelector((state) => state.dataValidation);

  const steps = [
    { id: 1, label: "Upload" },
    { id: 2, label: "Process" },
    { id: 3, label: "Review" },
  ];

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    const fileData = {
      file: file,
      name: file.name,
      folderName: loadIds,
    };

    try {
      setIsFileUploading(true);
      setIsFileUploadProgress(0);
      await new Promise((resolve) => {
        let currentProgress = 0;
        const interval = setInterval(() => {
          currentProgress += 1;
          setIsFileUploadProgress(currentProgress);
          if (currentProgress >= 90) {
            clearInterval(interval);
            resolve();
          }
        }, 333);
      });
      const res = await uploadFileApi(fileData);
      setTimeout(() => {
        setIsFileUploading(false);
      }, 1000);
    } catch (error) {
      console.error("File upload failed", error);

      setIsFileUploadProgress(0);
      setIsFileUploading(false);
    } finally {
      event.target.value = "";
    }
  };

  const fileUpload = async (s3Url, formData) => {
    return await axios
      .post(s3Url, formData, {
        headers: "multipart/form-data",
      })
      .then((res) => res)
      .catch((err) => {
        throw new Error(err.message);
      });
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const randomProgress = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const validationFinished = useRef(false);
  const lambdaFinished = useRef(false);

  const startInitialProgress = async () => {
    let current = 0;

    while (current < 50) {
      current = Math.min(current + randomProgress(2, 5), 50);

      setProgress(current);

      await delay(randomProgress(8000, 12000));
    }

    setProgress(50);
  };

  const continueProgressTo90 = async () => {
    let current = 50;

    while (!lambdaFinished.current && current < 90) {
      current = Math.min(current + randomProgress(2, 7), 90);

      setProgress(current);

      await delay(randomProgress(4000, 7000));
    }
  };

  const uploadFileApi = async (fileData) => {
    const file = new File(
      [
        `s3://${process.env.REACT_APP_DATA_VALIDATION_BUCKET_NAME}/INPUT/${loadIds}`,
      ],
      fileData.file.name || "input.csv",
      {
        type: "csv",
      },
    );

    try {
      const payload = {
        folder_name: loadIds,
        file_name: file.name,
      };
      const uploadResult = await dispatch(
        dataValidationUploadProcess(payload),
      ).unwrap();

      if (uploadResult?.status !== 200) {
        throw new Error("File upload failed");
      }
      const { url, fields } = uploadResult.data.signed_url;
      if (url) {
        setIsFileUploadProgress(100);
        toast.success("File uploaded successfully");
      }
      const formData = new FormData();
      Object.keys(fields).forEach((key) => {
        formData.append(key, fields[key]);
      });
      formData.append("file", fileData.file);
      for (const [key, value] of formData.entries()) {
        if (key === "file") {
        } else {
        }
      }

      await delay(2000);
      try {
        const S3URL = await fileUpload(url, formData);
      } catch (error) {
        console.log("S3 upload failed:", error.response?.status);
        console.log("S3 error:", error.response?.data);
      }
      dispatch(
        setUploadFile({
          name: file.name,
          folderName: loadIds,
        }),
      );

      await delay(2000);

      const validationResult = await dispatch(
        dataValidationFileValidation({
          folder_name: loadIds,
          file_name: fileData.file.name,
        }),
      ).unwrap();

      if (validationResult?.status !== 200) {
        throw new Error("Validation failed");
      }
      // toast.success("Validation completed successfully");
      toast.info("Processing is in progress. Please wait a moment.");
      const jobId = validationResult.data.job_run_id;
      dispatch(setActiveStep(2));
      // await delay(5000)
      let validationTracking;
      let firstTime = true;

      while (true) {
        // startInitialProgress();
        // await delay(120000);
        validationTracking = await dispatch(
          validationFileTraking({
            job_run_id: jobId,
            folder_name: loadIds,
          }),
        ).unwrap();

        if (validationTracking.data.status === "processing") {
          if (firstTime) {
            firstTime = false;

            // Animate 0 -> 50 during these 2 minutes
            await startInitialProgress();
          } else {
            // Keep progress at 50 while waiting
            setProgress(50);

            await delay(60000);
          }

          continue;
        }

        if (validationTracking.data.glue_status === "FAILED") {
          // toast.error("Glue validation job failed with status");
          dispatch(setDataValidationErrorModal(true));
          return;
        }

        if (validationTracking.data.glue_status === "SUCCEEDED") {
          if (validationTracking.data.validation === "failed") {
            // toast.error("Glue validation job failed with the uploaded file");
            dispatch(setDataValidationErrorModal(true));
            return;
          }

          if (validationTracking.data.validation === "passed") {
            toast.info("Hold on, Please wait—it may take a few more moments");
            // toast.success("Validation completed successfully");
            setProgress(50);
          }
          break;
        }
      }

      const conversionResult = await dispatch(
        dataValidationFileConversion({
          folder_name: loadIds,
          file_name: fileData.file.name,
        }),
      ).unwrap();

      if (conversionResult.status !== 200) {
        toast.error("Conversion Failed");
        dispatch(setDataValidationErrorModal(true));
        return;
      }
      // toast.success("Conversion Completed");
      const jobId1 = conversionResult.data.job_run_id;
      let conversationTracking;
      let conversationFirstTime = true;

      while (true) {
        // continueProgressTo90();
        // await delay(120000);
        conversationTracking = await dispatch(
          conversionFileTracking({
            job_run_id: jobId1,
            folder_name: loadIds,
          }),
        ).unwrap();

        if (conversationTracking.data.status === "processing") {
          if (conversationFirstTime) {
            conversationFirstTime = false;
            await continueProgressTo90();
          } else {
            setProgress(90);
            await delay(60000);
          }
          continue;
        }
        if (conversationTracking.data.glue_status === "FAILED") {
          // toast.error("Glue Failed");
          dispatch(setDataValidationErrorModal(true));
          return;
        }

        if (conversationTracking.data.glue_status === "SUCCEEDED") {
          toast.success("Conversion completed successfully");
          setProgress(100);
          // toast.success("Validation Completed");
          dispatch(setActiveStep(3));
          await delay(2000);
          try {
            const downloadResult = await dispatch(
              dataValidationFileDownloadValidation({
                file_name: fileData.file.name,
                folder_name: loadIds,
              }),
            ).unwrap();

            if (downloadResult?.status && downloadResult.status !== 200) {
              toast.error("Download file generation failed.");
              // dispatch(setDataValidationErrorModal(true));
              return;
            }
            toast.success(
              "Your file is ready for download. Please download it.",
            );
            dispatch(setActiveStep(3));
            break;
          } catch (err) {
            toast.error("File Download failed.");
            // dispatch(setDataValidationErrorModal(true));
            return;
          }
          break;
        }
      }
    } catch (error) {
      toast.error(error.message || "Process failed");

      console.error(error);
    }
  };

  const renderUploadScreen = () => (
    <Box
      sx={{
        maxWidth: 900,
        width: "100%",
        border: "1px solid #D6E4FF",
        mx: "auto",
        py: { xs: 2, sm: 3, md: 4 },
        borderRadius: 3,
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          bgcolor: "#fff",
          m: 2,
        }}
      >
        {isFileUploading && (
          <Box sx={{ m: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 0.5,
              }}
            >
              <Typography variant="body2">
                {isFileUploadProgress === 100 ? "Completed" : "Uploading..."}
              </Typography>

              <Typography variant="body2" fontWeight={600}>
                {isFileUploadProgress}%
              </Typography>
            </Box>

            <LinearProgress
              variant="determinate"
              value={isFileUploadProgress}
              sx={{
                height: 12,
                borderRadius: 4,
              }}
            />
          </Box>
        )}
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: "50%",
            bgcolor: "#F5F7FA",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 1,
          }}
        >
          <Avatar
            src={DataValidationUploadIcon}
            sx={{
              width: 40,
              height: 40,
              bgcolor: "transparent",
            }}
            imgProps={{
              style: {
                objectFit: "contain",
              },
            }}
          />
        </Box>
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv"
          hidden
          onChange={handleFileChange}
        />
        <Typography fontWeight={500} fontSize={20} sx={{ textAlign: "center" }}>
          Select your dataset
        </Typography>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          sx={{
            borderRadius: 2,
            px: 6,
            py: 1,
            textTransform: "none",
            bgcolor: "#003F87",
            "&:hover": {
              bgcolor: "#003F87",
            },
          }}
          onClick={handleBrowseClick}
        >
          Browse Files
        </Button>
      </Box>


      <Paper
        elevation={0}
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
          py: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "stretch", sm: "center" },
            gap: 2,
          }}
        >
          {/* File Info */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              // flex: 1,
              p: 2,
              borderRadius: 2,
              // bgcolor: "#F6F6F6",
              minWidth: 0, // allows text truncation
            }}
          >

          </Box>

          {/* Change File Button */}
          <Button
            variant="text"
            startIcon={<RefreshIcon fontSize="small" />}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              color: "#1565C0",
              alignSelf: { xs: "stretch", sm: "center" },
              justifyContent: "center",
              whiteSpace: "nowrap",
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
            disabled={!uploadFile?.name}
            onClick={handleBrowseClick}
          >
            Change File
          </Button>
        </Box>
      </Paper>
    </Box>
  );

  const renderProcessScreen = () => {
    const processSteps = [
      {
        title: "File uploaded",
        progress: 10,
      },
      {
        title: "Schema validation",
        progress: 25,
      },
      {
        title: "Business rule validation",
        progress: 50,
      },
      {
        title: "Data quality checks",
        progress: 75,
      },
      {
        title: "Duplicate detection",
        progress: 90,
      },
      {
        title: "Finalizing dataset",
        progress: 100,
      },
    ].map((step) => ({
      ...step,
      completed: progress >= step.progress,
      active: progress < step.progress && progress >= step.progress - 15,
    }));

    // const activeStep = Math.floor((progress / 100) * steps.length);

    // const processSteps = steps.map((title, index) => ({
    //   title,
    //   completed: index < activeStep,
    //   active: index === activeStep && progress < 100,
    // }));

    return (
      <>
        <Box
          sx={{
            bgcolor: "#EEF5FF",
            border: "1px solid #D6E4FF",
            borderRadius: 1,
            p: 1,
            mb: 3,
            width: "70%",
            mx: "auto",
          }}
        >
          <Typography fontSize={13} color="#0B5ED7">
            Validation is currently in progress. Please keep this page open
            until processing is complete.
          </Typography>
        </Box>

        <Box
          sx={{
            p: 4,
            borderRadius: 3,
            mb: 3,
            mx: "auto",
            width: "70%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: "1px solid #e5e5e5",
            gap: 4,
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "inline-flex",
            }}
          >
            <CircularProgress
              variant="determinate"
              value={100}
              size={140}
              thickness={5}
              sx={{
                color: "#E5E7EB",
                position: "absolute",
              }}
            />

            <CircularProgress
              variant="determinate"
              value={progress}
              size={140}
              thickness={5}
              sx={{
                color: "#003F87",
              }}
            />

            {/* Label */}
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "#003F87", fontWeight: 600, textAlign: "center" }}
              >
                {progress === 100 ? (
                  <>
                    <span
                      style={{
                        display: "block",
                        width: "100%",
                        textAlign: "center",
                        fontSize: "14px",
                        fontWeight: "600",
                        // color: "#424752"
                      }}
                    >
                      {progress}%
                    </span>
                    <span
                      style={{
                        display: "block",
                        textAlign: "center",
                        color: "#424752",
                        fontSize: "14px",
                      }}
                    >
                      100% <br></br> Completed
                    </span>
                  </>
                ) : (
                  <>
                    <span
                      style={{
                        display: "block",
                        width: "100%",
                        textAlign: "center",
                        fontSize: "19px",
                        fontWeight: "600",
                      }}
                    >
                      {progress}%
                    </span>
                    <span
                      style={{
                        display: "block",
                        textAlign: "center",
                        color: "#424752",
                      }}
                    >
                      In Progress
                    </span>
                  </>
                )}
              </Typography>
            </Box>
          </Box>

          <Box>
            <Typography fontSize={20} fontWeight={700}>
              Validating your dataset...
            </Typography>

            <Typography style={{ color: "#424752" }} mt={1} fontSize={15}>
              Healthcare records are currently being validated against business
              rules.
            </Typography>

            <Typography
              fontSize={15}
              sx={{
                color: "#0B5ED7",
                fontWeight: 600,
                mt: 2,
                mb: 3,
              }}
            >
              {/* Estimated time: {"timeText"} */}
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              {processSteps.map((item) => (
                <Box
                  key={item.title}
                  sx={{
                    width: "calc(50% - 8px)",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      bgcolor: item.completed
                        ? item.active
                          ? "#EEF5FF"
                          : "#F6F6F6"
                        : "transparent",
                      p: 1,
                      borderRadius: 1,
                    }}
                  >
                    {item.completed ? (
                      <CheckCircleIcon
                        sx={{
                          color: "#198754",
                          mr: 1,
                        }}
                      />
                    ) : (
                      <RadioButtonUncheckedIcon
                        sx={{
                          color: "#BDBDBD",
                          mr: 1,
                        }}
                      />
                    )}

                    <Typography
                      fontSize={14}
                      sx={{
                        color: item.active
                          ? "#003F87"
                          : item.completed
                            ? "#1B1C1C"
                            : "#9E9E9E",
                        fontWeight: item.active ? 600 : 400,
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            borderRadius: 3,
            p: 2,
            width: "70%",
            margin: "auto",
            border: "1px solid #C2C6D4",
            background: "#F6F6F6",
            border: "1px solid #e5e5e5",
          }}
        >
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: 40,
                height: 40,
                bgcolor: "#F5F7FA",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mr: 3,
              }}
            >
              <Avatar
                src={DataValidationPatientRecord}
                variant="square"
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: "#EAE8E7",
                  borderRadius: "10px",
                  alignItems: "center",
                  p: 1,
                }}
                imgProps={{
                  style: {
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  },
                }}
              />
            </Box>

            <Box>
              <Typography fontWeight={500} sx={{ fontSize: "14px" }}>
                {uploadFile.name?.length > 0
                  ? uploadFile.name
                  : "Please upload a CSV file"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </>
    );
  };

  const downloadUrl =
    dataValidationFileDownloadValidationData?.data?.data?.url || null;

  const hasDownloadFile = !!downloadUrl;

  const renderReviewScreen = () => {
    return (
      <>
        <Box
          sx={{
            maxWidth: 900,
            mx: "auto",
            p: 4,
            borderRadius: 3,
            border: "1px solid #e5e5e5",
          }}
        >
          <Box display="flex" justifyContent="center">
            <Box
              sx={{
                position: "relative",
                display: "inline-flex",
              }}
            >
              <CircularProgress
                variant="determinate"
                value={100}
                size={140}
                thickness={5}
                sx={{
                  color: "#E5E7EB",
                  position: "absolute",
                }}
              />

              <CircularProgress
                variant="determinate"
                value={100}
                size={140}
                thickness={5}
                sx={{
                  color: "#003F87",
                }}
              />

              {/* Label */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography fontWeight={600}>
                  <span
                    style={{
                      display: "block",
                      width: "100%",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: "600",
                      // color: "#424752"
                    }}
                  >
                    100% <br></br> Completed
                  </span>
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Title */}
          <Typography align="center" fontWeight={700} fontSize={20} mt={2}>
            Validation Completed Successfully
          </Typography>

          <Typography align="center" color="#666" mt={1} mb={2} fontSize={15}>
            Your dataset has been successfully validated and is ready
            <br />
            for review.
          </Typography>

          <Box
            sx={{
              bgcolor: "#DFF6E5",
              border: "1px solid #B9E7C5",
              borderRadius: 2,
              py: 1.5,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 3,
            }}
          >
            <CheckCircleIcon
              sx={{
                color: "#0F8A3B",
                mr: 1,
                fontSize: 20,
              }}
            />

            <Typography
              sx={{
                color: "#0F8A3B",
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              All validation checks have completed successfully.
            </Typography>
          </Box>
        </Box>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="flex-end"
          mt={2}
          sx={{ maxWidth: 900, mx: "auto", p: 4 }}
        >
          <Button
            variant="outlined"
            startIcon={<AddCircleOutlineIcon />}
            onClick={() => {
              dispatch(
                setUploadFile({
                  name: "",
                  folderName: "",
                }),
              );
              dispatch(setActiveStep(1));
              setProgress(0);
            }}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 3,
            }}
          >
            Start New Validation
          </Button>
          <Button
            variant="contained"
            startIcon={<DownloadIcon />}
            sx={{
              textTransform: "none",
              bgcolor: "#003F87",
              borderRadius: 2,
              px: 3,
              "&:hover": {
                bgcolor: "#003F87",
              },
            }}
            // onClick={handleFileDownload}
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download HCP FILE
          </Button>
        </Stack>
      </>
    );
  };

  const renderStepContent = () => {
    switch (activeStep) {
      case 1:
        return renderUploadScreen();

      case 2:
        return renderProcessScreen();

      case 3:
        return renderReviewScreen();

      default:
        return renderUploadScreen();
    }
  };

  return (
    <Container className="p-0 fluid">
      <ToastContainer position="top-right" autoClose={3000} />
      <section className="discovery_compaion_main_container">
        <div className="discovery_compaion_main_container_top">
          <h1 className="discovery_compaion_main_container_title">
            Episode Data Upload
          </h1>
          <h3 className="discovery_compaion_main_container_subtitle">
            Upload healthcare datasets to securely validate records against
            enterprise compliance standards.
          </h3>
        </div>
        <div className="stepper">
          {steps.map((step, index) => {
            const isActive = activeStep === step.id;
            const isCompleted = activeStep > step.id;

            return (
              <div
                key={step.id}
                className="step"
                style={{
                  flex: step.id === 3 ? "0 0 auto" : 1,
                  cursor: "pointer",
                }}
                onClick={() => dispatch(setActiveStep(step.id))}
              >
                <div
                  className="circle"
                  style={{
                    background: isActive || isCompleted ? "#003F87" : "#E5E7EB",
                    color: isActive || isCompleted ? "#fff" : "#1B1C1C",
                    border: isActive
                      ? "2px solid #003F87"
                      : "2px solid #D9D9D9",
                  }}
                >
                  {step.id}
                </div>

                <div
                  style={{
                    margin: "10px",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: isActive || isCompleted ? "#003F87" : "#1B1C1C",
                  }}
                >
                  {step.label}
                </div>

                {index !== steps.length - 1 && <div className="line"></div>}
              </div>
            );
          })}
        </div>
      </section>
      {renderStepContent()}
      <Dialog open={dataValidationErrorModal} maxWidth="md" fullWidth>
        <DialogContent sx={{ p: 4 }}>
          {/* Header */}

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Box>
              <Typography fontSize={20} fontWeight={700} color="#D32F2F">
                Error Issues
              </Typography>

              <Typography
                // mt={1}
                color="#666"
                fontSize={14}
              >
                Please review the following, make the necessary corrections, and
                upload it again.
              </Typography>
            </Box>

            <IconButton
              onClick={() => {
                dispatch(setActiveStep(1));
                dispatch(
                  setUploadFile({
                    name: "",
                    folderName: "",
                  }),
                );
                dispatch(setDataValidationErrorModal(false));
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Summary */}

          {/* <Box mt={4}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography fontWeight={700} fontSize={13} color="#666">
                VALIDATION SUMMARY
              </Typography>

              <Chip
                label="Completed with Issues"
                sx={{
                  bgcolor: "#FFF7E8",
                  color: "#8A5A00",
                  fontWeight: 600,
                }}
              />
            </Box>
          </Box> */}

          {/* Downloads */}

          <Box mt={3}>
            {/* Error Report */}

            <Paper
              variant="outlined"
              sx={{
                p: 2,
                borderRadius: 2,
                mb: 2,
                borderColor: "#D32F2F",
                bgcolor: "#FFF5F5",
              }}
            >
              <Stack direction="row" spacing={2} alignItems="center">
                <ErrorOutlineIcon
                  sx={{
                    color: "#D32F2F",
                    mt: 0.2,
                  }}
                />

                <Box sx={{width:"100%"}}>
                  <Box>
                    {/* <Typography
                      variant="subtitle1"
                      sx={{ color: "#D32F2F", fontWeight: 700, mb: 1 }}
                    >
                      Header Validation Failed
                    </Typography> */}
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      // sx={{ mb: 1.5 }}
                    >
                      {(dataValidationFileTraking?.data?.data?.glue_status ===
                        "FAILED" ||
                        dataConversionFileTracking?.data?.data?.glue_status ===
                          "FAILED") && (
                        <div>
                          The{" "}
                          {dataValidationFileTraking?.data?.data
                            ?.glue_status === "FAILED"
                            ? "Validation "
                            : "Conversion "}
                          Glue Job failed due to errors in the Glue code, and
                          the uploaded file was not processed
                        </div>
                      )}
                    </Typography>
                    {dataValidationFileTraking?.data?.data?.error_csv_url && (
                      <Box>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          // sx={{ mb: 1.5 }}
                        >
                          Issues were found in the file. Please download the
                          file, review the issues, and try uploading it again
                        </Typography>
                        <Box sx={{ m: 1.5, display:"flex", justifyContent: "end" }}>
                          <Button
                            variant="contained"
                            startIcon={
                              <Box
                                component="img"
                                src={ErrorDownloadIcon}
                                alt="Download"
                                sx={{
                                  width: 20,
                                  height: 20,
                                  objectFit: "none",
                                  display: "block",
                                }}
                              />
                            }
                            sx={{
                              minWidth: 145,
                              height: 44,
                              bgcolor: "#124D82",
                              borderRadius: "6px",
                              textTransform: "none",
                              fontSize: "16px",
                              fontWeight: 500,
                              flexShrink: 0,

                              "&:hover": {
                                bgcolor: "#0D3E6A",
                              },

                              "& .MuiButton-startIcon": {
                                marginRight: "3px",
                              },
                            }}
                            href={
                              dataValidationFileTraking?.data?.data
                                ?.error_csv_url
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            //     onClick={() => {
                            //     dataValidationFileTraking?.data?.data?.error_csv_url;
                            // }}
                          >
                            Download
                          </Button>
                        </Box>
                      </Box>
                    )}
                        {!dataValidationFileValidationData?.error &&
                        !dataValidationFileConversionData?.error &&
                        !dataValidationFileTraking?.data?.data?.glue_status && 
                        !dataValidationFileTraking?.data?.data?.error_csv_url && 
                        !!dataValidationFileTraking?.data?.data?.glue_status && (
                          <Typography variant="body2" color="error">
                            File upload error.
                          </Typography>
                        )}
                  </Box>
                </Box>
              </Stack>
            </Paper>

            {/* Warning Report */}
          </Box>

          {/* Next Steps */}

          <Divider sx={{ my: 2 }} />

          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="outlined"
              onClick={() => {
                dispatch(setActiveStep(1));
                dispatch(
                  setUploadFile({
                    name: "",
                    folderName: "",
                  }),
                );
                dispatch(setDataValidationErrorModal(false));
              }}
              sx={{
                textTransform: "none",
                px: 4,
              }}
            >
              Close
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default DataValidation;
